import cookie from 'react-cookies';
import translationTypes from '../actionTypes/language';
import { getLanguageListApi, getTranslationsApi } from '../../api/apiUrls/translation';

const getLanguageListStart = () => ({ type: translationTypes.GET_LANGUAGE_START });
const getLanguageListSuccess = (payload) => ({
  type: translationTypes.GET_LANGUAGE_SUCCESS,
  payload,
});
const getLanguageListFail = () => ({ type: translationTypes.GET_LANGUAGE_FAIL });

const getLanguageList = () => (dispatch) => {
  dispatch(getLanguageListStart());
  return getLanguageListApi()
    .then((res) => {
      dispatch(getLanguageListSuccess(res.data.data));
    })
    .catch(() => {
      dispatch(getLanguageListFail());
    });
};

const getTranslationsStart = () => ({ type: translationTypes.GET_TRANSLATIONS_START });
const getTranslationsSuccess = (payload) => ({
  type: translationTypes.GET_TRANSLATIONS_SUCCESS,
  payload,
});
const getTranslationsFail = () => ({ type: translationTypes.GET_TRANSLATIONS_FAIL });

const getTranslations = () => (dispatch) => {
  dispatch(getTranslationsStart());
  return getTranslationsApi()
    .then((res) => {
      dispatch(getTranslationsSuccess(res.data.data));
    })
    .catch(() => {
      dispatch(getTranslationsFail());
    });
};

const setLanguage = (lang) => (dispatch) => {
  dispatch({ payload: lang, type: translationTypes.SET_LANGUAGE });
  cookie.save('lang_market', lang, { path: '/', maxAge: (Date.now() / 1000) + (60 * 60 * 24 * 365) });
};

const translationActions = {
  getLanguageList,
  getTranslations,
  setLanguage,
};

export default translationActions;
